let actions = {
    updateLoggingIn({commit},loginData){
        /***
         * Acción que llama a la mutación de inicio de sesión
         */
        commit('updateLoggingIn',loginData)
    },
    updateToken({commit},tokenData){
        /***
         * Acción que llama a la mutación de actualización del token
         */
        commit('updateToken',tokenData)
    },
    logout({commit}) {
        /***
         * Acción que llama a la mutación de cierre de sesión
         */
        commit('logout','');
    },
    resetState({commit}) {
        commit('resetState','');
    },
    idleSet({commit}) {
        commit('idleSet');
    },
    setResetUser({commit},resetData){
        /***
         * Acción que llama a la mutación de reseteo de contraseña
         */
        commit('updateLoggingIn',resetData)
    },
    setLogoutState({commit},status) {
        commit('setLogoutState',status)
    }
}
export default actions
